'use strict';exports.__esModule = true;exports.googleTagLoader = exports.googleAuthSDKLoader = exports.facebookSDKLoader = exports.googleRemarketingLoader = exports.loadMarkerClusterer = exports.googleReCaptchaLoader = exports.googleSDKLoader = exports.scriptLoader = undefined;var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _constants = require('../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var googleSdkLink = _constants.googleSdkConfig.libUrl + '&v=' + _constants.googleSdkConfig.version + '&key=' + _constants.googleSdkConfig.apiKey + '&language=';
var googleTagLink = 'https://www.googletagmanager.com/gtag/js?id=' + _constants.analytics.google.trackingId;

var scriptLoader = exports.scriptLoader = function scriptLoader(url) {return new Promise(function (resolve, reject) {
    if (!global.document) {
      reject({ code: 'SSR', message: 'Server side script load attempt failed, no DOM constructed yet.' });
    } else {
      var anchorNode = global.document.getElementsByTagName('script')[0];

      if (anchorNode.src !== url) {
        var script = global.document.createElement('script');

        script.type = 'text/javascript';
        script.src = url;
        script.defer = true;

        var handleLoad = function handleLoad(event) {
          resolve(event);
          script.removeEventListener('load', handleLoad);
        };

        var handleError = function handleError(err) {
          reject(err);
          script.removeEventListener('error', handleError);
        };
        script.addEventListener('load', handleLoad);
        script.addEventListener('error', handleError);

        anchorNode.parentNode.insertBefore(script, anchorNode);
      } else {
        var _script = url.split('/').reverse()[0];

        resolve();
      }
    }
  });};

var persistentScriptLoader = function persistentScriptLoader(link, object) {var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;var requiredPath = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var objectAlreadyExists = global[object] || window[object];
  var requiredPathAlreadyExist = (0, _get2.default)(global, requiredPath) || (0, _get2.default)(window, requiredPath);

  return !objectAlreadyExists || requiredPath && !requiredPathAlreadyExist ?
  scriptLoader(link).
  then(function () {return new Promise(function (resolve) {
      var objectLoaded = global[object] || window[object];
      var requiredPathLoaded = (0, _get2.default)(global, requiredPath) || (0, _get2.default)(window, requiredPath);

      if (!objectLoaded || requiredPath && !requiredPathLoaded) {
        var attempts = 0;
        // TODO: Possible issue with slow connections, may be switch to XHR + eval() approach
        var interval = setInterval(function () {
          var objectInited = global[object] || window[object];
          var requiredPathInited = (0, _get2.default)(global, requiredPath) || (0, _get2.default)(window, requiredPath);

          if (objectInited && (requiredPath ? requiredPathInited : true)) {
            resolve(global[object] || window[object]);
            clearInterval(interval);
          } else {
            attempts += 1;
            if (attempts > 1000) {
              console.error('Script load timing out');
              clearInterval(interval);
            }
          }
        }, time);
      } else {
        resolve(global[object] || window[object]);
      }
    });}) :
  Promise.resolve(global[object] || window[object]);

};


var buildFbLocale = function buildFbLocale(locale) {return locale === _constants.language.default ? locale + '_IL' : locale + '_' + locale.toUpperCase();};
var buildFbSdkLink = function buildFbSdkLink(locale) {return 'https://connect.facebook.net/' + buildFbLocale(locale) + '/sdk.js#xfbml=1&version=v2.12';};

// TODO: Try to synchronise the load of the google maps SDK (module exports)
var googleSDKLoader = exports.googleSDKLoader = function googleSDKLoader(locale) {return persistentScriptLoader(googleSdkLink + locale, 'google', 5, 'google.maps');};
var googleReCaptchaLoader = exports.googleReCaptchaLoader = function googleReCaptchaLoader(locale) {return persistentScriptLoader(_constants.googleReCaptchaConfig.url + locale, 'grecaptcha');};
var loadMarkerClusterer = exports.loadMarkerClusterer = function loadMarkerClusterer() {return persistentScriptLoader(_constants.googleSdkConfig.clustererLibUrl, 'MarkerClusterer');};
var googleRemarketingLoader = exports.googleRemarketingLoader = function googleRemarketingLoader() {return persistentScriptLoader(_constants.remarketing.url, 'google_trackConversion');};
var facebookSDKLoader = exports.facebookSDKLoader = function facebookSDKLoader(locale) {return scriptLoader(buildFbSdkLink(locale), 'facebook-jssdk');};
var googleAuthSDKLoader = exports.googleAuthSDKLoader = function googleAuthSDKLoader(locale) {return scriptLoader(_constants.googleSdkConfig.authLibUrl + '?language=' + locale);};
var googleTagLoader = exports.googleTagLoader = function googleTagLoader() {return scriptLoader(googleTagLink);};


//////////////////
// WEBPACK FOOTER
// ./src/helpers/scriptLoaders.js
// module id = 282
// module chunks = 0